import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ChapterSettingsComponent } from "./chapter-settings/chapter-settings.component";
import { SectionSettingsComponent } from "./section-settings/section-settings.component";
import { FieldSettingsComponent } from "./field-settings/field-settings.component";
import { FieldTypeSelectorComponent } from "./field-type-selection/field-type-selector.component";
import { FormBuilderService } from "../../../services/form-builder.service";
import { MainSettingsComponent } from "./main-settings/main-settings.component";

@Component({
  selector: 'app-settings-side-menu',
  standalone: true,
  templateUrl: './settings-side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ChapterSettingsComponent,
    SectionSettingsComponent,
    FieldSettingsComponent,
    FieldTypeSelectorComponent,
    MainSettingsComponent
  ]
})

export class SettingsSideMenuComponent {
  protected fbService = inject(FormBuilderService);

}
